import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SignedDocument} from '../../../models/signed_document';
import {SignedDocumentsService} from '../signed-documents.service';
import { PdfDocument } from 'src/app/models/pdf_document';

@Component({
  selector: 'signed-document-item',
  templateUrl: './signed-document-item.component.html',
  styleUrls: ['./signed-document-item.component.scss'],
})
export class SignedDocumentItemComponent implements OnInit {
  @Input() documents: (SignedDocument | PdfDocument)[];
  @Input() showBackground: boolean = false;
  @Input() iconName: string;
  @Input() iconColor: string;
  @Input() allowMultiple: boolean = true;
  @Output() documentSelected = new EventEmitter<SignedDocument | PdfDocument>()

  constructor(public signedDocumentService: SignedDocumentsService) {}

  ngOnInit() {}

  verifySelectedStatus(document: SignedDocument | PdfDocument): boolean {
    return this.signedDocumentService.selectedDocuments.indexOf(document) > -1
  }

  selectDocument(document: SignedDocument | PdfDocument) {
    this.iconName = "checkmark-circle"
    this.iconColor = "success"
    this.documentSelected.emit(document)
  }
}
